<template>
  <div>
    <h3 class="mb-2 mt-3">Transactions History</h3>
    <div v-for="transaction in rewardTransactions">
      <transaction :transaction="transaction" :source="source"></transaction>
    </div>
  </div>
</template>

<script>
import Transaction from './Transaction'

export default {
  name: "Transactions",
  props: ['rewardTransactions', 'source'],
  components: {Transaction},
}
</script>

<style scoped>

</style>
